import { useState, useEffect } from 'react';
import {
  isTraktConfigured,
  fetchUserProfile,
  fetchUserStats,
  fetchTopRatedMovies,
  fetchCurrentlyWatching,
  fetchRecentHistory,
  getMockData,
  type TraktUser,
  type UserStats,
  type RatedMovie,
  type WatchedMovie,
  type WatchedEpisode,
  type CurrentlyWatching,
} from '../services/traktApi';
export const useTraktData = () => {
  const [user, setUser] = useState<TraktUser | null>(null);
  const [stats, setStats] = useState<UserStats | null>(null);
  const [topMovies, setTopMovies] = useState<RatedMovie[]>([]);
  const [currentlyWatching, setCurrentlyWatching] = useState<CurrentlyWatching | null>(null);
  const [recentMovies, setRecentMovies] = useState<WatchedMovie[]>([]);
  const [recentEpisodes, setRecentEpisodes] = useState<WatchedEpisode[]>([]);


  const [loading, setLoading] = useState(true);
  const [configured] = useState(isTraktConfigured());
  const [usingMockData, setUsingMockData] = useState(false);

  useEffect(() => {
    console.log('[useTraktData] Effect running, configured:', configured);
    
    const loadData = async () => {
      setLoading(true);

      if (!configured) {
        // Utiliser les données de démonstration
        console.warn('[useTraktData] Trakt not configured, using mock data');
        setUsingMockData(true);
        const mock = getMockData();
        setUser(mock.user);
        setStats(mock.stats);
        setTopMovies(mock.topMovies);
        setCurrentlyWatching(mock.currentlyWatching);
        setRecentMovies(mock.recentHistory.movies);
        setRecentEpisodes(mock.recentHistory.episodes);

        setLoading(false);
        return;
      }

      try {
        const [userData, statsData, moviesData, watchingData, historyData] = await Promise.all([
          fetchUserProfile(),
          fetchUserStats(),
          fetchTopRatedMovies(15),
          fetchCurrentlyWatching(),
          fetchRecentHistory(6),
        ]);

        setUser(userData);
        setStats(statsData);
        setTopMovies(moviesData);
        setCurrentlyWatching(watchingData);
        setRecentMovies(historyData.movies);
        setRecentEpisodes(historyData.episodes);
        setUsingMockData(false);
      } catch (error) {
        console.error('[useTraktData] Error caught:', error);
        // En cas d'erreur, utiliser les données mock
        setUsingMockData(true);
        const mockData = getMockData();
        setUser(mockData.user);
        setStats(mockData.stats);
        setTopMovies(mockData.topMovies);
        setCurrentlyWatching(mockData.currentlyWatching);
        setRecentMovies(mockData.recentHistory.movies);
        setRecentEpisodes(mockData.recentHistory.episodes);
      } finally {
        setLoading(false);
      }
    };

    loadData();
    // Rafraîchir toutes les 5 minutes
    const interval = setInterval(loadData, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [configured]);

  return { user, stats, topMovies, currentlyWatching, recentMovies, recentEpisodes, loading, configured, usingMockData };
};
